import { useLocale } from '@solinkcorp/locale';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@solinkcorp/solink-ui';
import { sdmCancelBtnStyles, sdmDialogContentStyles } from './LayoutSelectorStyles';

interface DeleteConfirmationProps {
  deleteConfirmLayout: {
    id: string;
    name: string;
  } | null;
  setDeleteConfirmLayout: (layout: { id: string; name: string } | null) => void;
  handleDelete: (id: string) => void;
}
const LayoutDeleteConfirmationDialog = (props: DeleteConfirmationProps) => {
  const locale = useLocale();
  const { deleteConfirmLayout, setDeleteConfirmLayout, handleDelete } = props;
  const message = locale.serviceDisplayMonitor.deleteLayoutConfirmation.replace(
    '{{name}}',
    deleteConfirmLayout?.name ?? '',
  );
  return (
    <Dialog
      open={!!deleteConfirmLayout}
      onOpenChange={(open) => !open && setDeleteConfirmLayout(null)}
    >
      <DialogContent className={sdmDialogContentStyles}>
        <DialogHeader>
          <DialogTitle>{locale.serviceDisplayMonitor.deleteLayout}</DialogTitle>
        </DialogHeader>
        {/*
          Single-line message: it lives in the body, not the header, so the dialog does not
          leave an empty block between the header and footer separators. DialogDescription
          stays sr-only for the accessible name.
        */}
        <DialogDescription className="sr-only">{message}</DialogDescription>
        <p className="body-md">{message}</p>
        <DialogFooter>
          <Button
            className={sdmCancelBtnStyles}
            onClick={() => setDeleteConfirmLayout(null)}
            type="button"
            variant="outline"
          >
            {locale.general.cancel}
          </Button>
          <Button
            className="cursor-pointer border-none bg-text-error text-white hover:text-white hover:bg-destructive/80"
            variant="default"
            type="button"
            onClick={async () => {
              if (deleteConfirmLayout) {
                await handleDelete(deleteConfirmLayout.id);
                setDeleteConfirmLayout(null);
              }
            }}
          >
            {locale.general.delete}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LayoutDeleteConfirmationDialog;
